/**
 * 文件上传配置
 * 集中管理上传相关的配置项
 */

// 上传方式
export const UPLOAD_MODE = {
  PROXY: 'proxy',       // 通过后端中转（推荐开发环境）
  DIRECT: 'direct',     // 前端直传OSS（推荐生产环境）
};

// 当前使用的上传方式
export const CURRENT_UPLOAD_MODE = process.env.REACT_APP_UPLOAD_MODE || UPLOAD_MODE.PROXY;

// 文件大小限制（字节）
export const UPLOAD_SIZE_LIMITS = {
  image: 5 * 1024 * 1024,        // 5MB
  video: 100 * 1024 * 1024,      // 100MB
  audio: 20 * 1024 * 1024,       // 20MB
  attachment: 10 * 1024 * 1024,  // 10MB
};

// 文件类型MIME映射
export const FILE_MIME_TYPES = {
  image: ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp'],
  video: ['video/mp4', 'video/avi', 'video/quicktime', 'video/x-msvideo', 'video/x-flv', 'video/x-matroska', 'video/webm'],
  audio: ['audio/mpeg', 'audio/wav', 'audio/aac', 'audio/flac', 'audio/ogg', 'audio/x-m4a'],
  attachment: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/plain']
};

// 文件扩展名提示
export const FILE_EXTENSION_HINTS = {
  image: '支持 JPG、PNG、GIF、WebP 格式',
  video: '支持 MP4、AVI、MOV、WebM 格式',
  audio: '支持 MP3、WAV、AAC、FLAC 格式',
  attachment: '支持 PDF、DOC、DOCX、XLS、XLSX、TXT 格式'
};

// OSS配置（生产环境）
export const OSS_CONFIG = {
  region: process.env.REACT_APP_OSS_REGION || 'oss-cn-hangzhou',
  bucket: process.env.REACT_APP_OSS_BUCKET || 'food-labels',
  cdnDomain: process.env.REACT_APP_CDN_DOMAIN || 'https://cdn.yourdomain.com',
  folder: {
    image: 'labels/images',
    video: 'labels/videos',
    audio: 'labels/audios',
    attachment: 'labels/attachments'
  }
};

// 上传超时时间（毫秒）
export const UPLOAD_TIMEOUT = {
  image: 60 * 1000,       // 1分钟
  video: 300 * 1000,      // 5分钟
  audio: 120 * 1000,      // 2分钟
  attachment: 60 * 1000   // 1分钟
};

// 图片压缩配置
export const IMAGE_COMPRESS_CONFIG = {
  enabled: true,
  maxWidth: 1920,       // 最大宽度
  maxHeight: 1920,      // 最大高度
  quality: 0.8,         // 压缩质量 0-1
  mimeType: 'image/jpeg'
};

// 视频压缩提示
export const VIDEO_COMPRESS_HINT = '建议上传前使用视频压缩工具，推荐分辨率：720p或1080p';

// 上传进度更新频率（毫秒）
export const PROGRESS_UPDATE_INTERVAL = 100;

// 并发上传数量限制
export const CONCURRENT_UPLOAD_LIMIT = 3;

// 错误重试配置
export const RETRY_CONFIG = {
  enabled: true,
  maxRetries: 3,        // 最大重试次数
  retryDelay: 2000      // 重试延迟（毫秒）
};

// 文件预览配置
export const PREVIEW_CONFIG = {
  image: {
    thumbnail: true,
    maxPreviewSize: 5 * 1024 * 1024  // 5MB以内才显示预览
  },
  video: {
    thumbnail: true,
    autoplay: false,
    controls: true
  },
  audio: {
    controls: true,
    preload: 'metadata'
  }
};

export default {
  UPLOAD_MODE,
  CURRENT_UPLOAD_MODE,
  UPLOAD_SIZE_LIMITS,
  FILE_MIME_TYPES,
  FILE_EXTENSION_HINTS,
  OSS_CONFIG,
  UPLOAD_TIMEOUT,
  IMAGE_COMPRESS_CONFIG,
  VIDEO_COMPRESS_HINT,
  PROGRESS_UPDATE_INTERVAL,
  CONCURRENT_UPLOAD_LIMIT,
  RETRY_CONFIG,
  PREVIEW_CONFIG
};
